const CalendarColorBadge = ({ color }: { color: string }) => {
  return (
    // 동적 클래스 인식 불가로 #fffff가 안보이는 이슈 있어서 style로 설정
    <div
      className={` flex w-4 h-4 rounded-[5px] flex-shrink-0 `}
      style={{ backgroundColor: color }}
    />
  );
};

export default CalendarColorBadge;
